import axios from "axios";
import "aws-sdk/dist/aws-sdk";

import { config } from "../configs";
import { getSessionToken } from "./getToken";

const createWorkItem = async (attributes, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/assets`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const createWorkItems = async (attributes, workEventID, orgID) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/workevents/${workEventID}/workitems`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getWorkItems = async (workEventID, orgID) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();

      const URL = `${config.baseURL}/workevents/${workEventID}/workitems?all=true`;
      // const URL = `${config.baseURL}/organizations/6SST/assets`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      // reject(error);
      resolve([]);
    }
  });
};

const removeWorkItems = async (orgID, workItemID) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();

      const URL = `${config.baseURL}/workitems/${workItemID}`;
      // const URL = `${config.baseURL}/organizations/6SST/assets`;
      const { data } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          itemId: workItemID,
          Organization: orgID,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      // reject(error);
      resolve([]);
    }
  });
};

const getWorkItem = async (workEventID, workItemID, orgID = null) => {
  const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
    ? JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
    : undefined;
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/workevents/${workEventID}/workitems/${workItemID}`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: org?.id,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const updateWorkItem = async (attributes, workEventID, workItemID, orgID) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/workevents/${workEventID}/workitems/${workItemID}`;
      const { data } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const workItemLogger = async (attributes, workEventID, workItemID) => {
  // console.log(
  //   `Sending ${attributes} to the backend for workitem ${workItemID} ...`
  // );
  const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
    ? JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
    : undefined;
  // check when worktimes when there is work time
  // try {
  //   const workItemTimes = await getWorkItemTimes(workEventID, workItemID);
  //   if (workItemTimes?.length) {
  //     if (attributes === "START") {
  //       if (!workItemTimes[workItemTimes?.length - 1]?.end) {
  //         return;
  //       }
  //     } else if (attributes === "STOP") {
  //       if (workItemTimes[workItemTimes?.length - 1]?.end) {
  //         return;
  //       }
  //     }
  //   }
  // } catch (error) {
  //   console.log(error);
  // }
  console.log(
    `Sending ${attributes} to the backend for workitem ${workItemID} ...`
  );
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/workevents/${workEventID}/workitems/${workItemID}/log/${attributes}`;
      const { data } = await axios({
        method: "PUT",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: org.id,
        },
        url: URL,
        // data: attributes,
      });
      resolve(data);
      console.log(
        `${attributes} call for workitem ${workItemID} has succeeded 🟢`
      );
    } catch (error) {
      console.log(
        `${attributes} call for workitem ${workItemID} has failed 🔴`
      );
      reject(error);
    }
  });
};

const getWorkItemTimes = async (workEventID, workItemID) => {
  const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
    ? JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
    : undefined;
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/workevents/${workEventID}/workitems/${workItemID}/worktimes?action_list=true`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: org.id,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getWorkItemActionChronology = async (
  workEventId,
  workItemId,
  actionListState
) => {
  return new Promise(async function (resolve, reject) {
    const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
      ? JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
      : undefined;
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/workevents/${workEventId}/workitems/${workItemId}/worktimes?action_list=${actionListState}`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: org.id,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getProcedureSummaryStatus = async (orgId, workEventId, workItemId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/workevents/${workEventId}/workitems/${workItemId}/procedure/status`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export {
  createWorkItem,
  getWorkItems,
  createWorkItems,
  removeWorkItems,
  updateWorkItem,
  getWorkItem,
  workItemLogger,
  getWorkItemTimes,
  getProcedureSummaryStatus,
  getWorkItemActionChronology,
};
